import type { SpaceSource } from './types';

/** Minimal source shape accepted by {@link generateOptimisticSpaceSources}. */
export type OptimisticSourceInput = {
	ari: string;
	url: string;
	sourceType: string;
	name?: string | null;
	conversationIds?: string[];
};

/**
 * Maps create/manage-modal sources into the store's {@link SpaceSource} shape for optimistic
 * `addSpace`/`patchSpace`/`setSelectedSpace` writes. `id` is seeded from `ari` as a placeholder until
 * the server assigns the real UUID on the next list/detail fetch. Pass `overrideConversationIds` to
 * force the rollup ids (used by For You, whose source `conversationIds` are zeroed upstream).
 */
export const generateOptimisticSpaceSources = (
	sources: readonly OptimisticSourceInput[],
	overrideConversationIds?: string[],
): SpaceSource[] =>
	sources.map((s) => ({
		id: s.ari,
		ari: s.ari,
		url: s.url,
		sourceType: s.sourceType,
		name: s.name,
		conversationIds: overrideConversationIds ?? s.conversationIds,
	}));
